
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.983","height":"14.969"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_24023","data-name":"Path 24023","d":"M13.112 1.328a2.1 2.1 0 00-2.973 0h0L1.806 9.661a.46.46 0 00-.119.206l-1.1 3.96a.467.467 0 00.573.575l3.957-1.1a.46.46 0 00.206-.119l8.333-8.333a2.1 2.1 0 000-2.973zm-7.79 11.859L1.806 9.661M13.16 5.352L9.637 1.826","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.1"}})])
          )
        }
      }
    